var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 72.9677C57.7599 72.9677 72.9677 57.7599 72.9677 39C72.9677 20.2401 57.7599 5.03226 39 5.03226C20.2401 5.03226 5.03226 20.2401 5.03226 39C5.03226 57.7599 20.2401 72.9677 39 72.9677ZM39 78C60.5391 78 78 60.5391 78 39C78 17.4609 60.5391 0 39 0C17.4609 0 0 17.4609 0 39C0 60.5391 17.4609 78 39 78Z",
    fill: "#F6C746"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4266 39.4706C48.2569 37.2534 49.6078 34.4932 49.6078 31.914C49.6078 26.5747 45.9908 23 40.4128 23C35.0092 23 31.6537 26.3937 31 31.371L35.5757 32.276C35.8372 29.6516 37.5367 27.8869 40.2385 27.8869C42.8096 27.8869 44.5092 29.4706 44.5092 31.8235C44.5092 33 43.594 34.81 42.156 36.6199L31.2179 50.3303V53H50V48.0679H39.3234L46.4266 39.4706Z",
    fill: "#F6C746"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge2);
export default __webpack_public_path__ + "static/media/badge2.08380bb52eec8cbd9b413b71e470add8.svg";
export { ForwardRef as ReactComponent };